<!-- -->
<template>
  <div class="card-item">
    <div class="title">{{title}}</div>
    <div class="num">{{Number(num.toFixed(2))}}</div>
    <div class="before" :class="{'success':num>before}">
      {{getSum(num,before)}}%
      <i v-if="num>before" class="el-icon-caret-top"></i>
      <i v-else-if="before>num" class="el-icon-caret-bottom"></i>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:String,
    num:Number,
    before:Number,
  },
  name: "card-item",
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {
    getSum(num,before){
      if(num===before){
        return 0;
      }
      if(before===0){
        return num;
      }
      return (((num-before)/before)*100).toFixed(2);
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.card-item{
  width: 200px;
  height: 120px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  .title{
    font-weight: bold;
    font-size: 16px;
  }
  .num{
    font-size: 30px;
    font-weight: bold;
  }
  .before{
    color: @danger;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    &.success{
      color: @success;
    }
  }
}
</style>
